import type { ProductAd, ProductAdsAPIResponse } from '@/scopes/product-ads/domain/types'
import type { ProductAdsMapper } from './productAdsMapper'
import {
  createQueryStringSerializer,
  type QueryStringSerializer,
} from '@/scopes/common/infrastructure/query-strings/queryStringSerializer'
import defaultFetch from 'isomorphic-unfetch'
import { createProductAdsMapper } from './productAdsMapper'

interface Dependencies {
  env: {
    NEXT_PUBLIC_API_BASE_URL: string
  }
  fetch: typeof defaultFetch
  queryStringSerializer: QueryStringSerializer
  productAdsMapper: ProductAdsMapper
}

export function createProductAdsAPIClient(dependencies: Partial<Dependencies> = {}) {
  const {
    env = {
      NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
    },
    fetch = defaultFetch,
    queryStringSerializer = createQueryStringSerializer(),
    productAdsMapper = createProductAdsMapper(),
  } = dependencies as Dependencies

  async function getFilteredProductAds(contextItemId: string, filters?: Record<string, unknown>): Promise<ProductAd[]> {
    const queryString = queryStringSerializer.serialize({
      contextItemId,
      ...filters,
    })
    const response = await fetch(`${env.NEXT_PUBLIC_API_BASE_URL}/ProductAdsApi/GetProductAds?${queryString}`)

    const data: ProductAdsAPIResponse = await response.json()

    return productAdsMapper.map(data)
  }

  async function notifyHomepageAds(endpoint: string): Promise<{ success: true }> {
    const response = await fetch(endpoint)

    if (!response.ok) {
      const error = new Error(`[Product Ads] Response notifying status: ${endpoint}`)
      if (window.newrelic) {
        window.newrelic.noticeError(error)
      }
      throw error
    }

    return { success: true }
  }

  return {
    notifyHomepageAds,
    getFilteredProductAds,
  }
}
